export default {
    navigationBarTitleText: intl.get('mobileLandingPage.title.downloadApp'),
    navigationBarBackgroundColor: "#DF773C",
};
